import React, { ReactElement } from 'react';
import { CalendarBase } from '~components/calendar-base';
import { useCalendarViewStyles } from './calendar-view.styles';
import { CalendarViewProps } from './calendar-view.types';

export function CalendarView({ biId, id, month, monthsToShow = 1, renderDay }: CalendarViewProps): ReactElement {
	const { classes } = useCalendarViewStyles();

	return (
		<div className={classes.root} id={id}>
			<CalendarBase biId={biId} month={month} monthsToShow={monthsToShow} navigation="none" renderDay={renderDay} />
		</div>
	);
}

CalendarView.Day = CalendarBase.Day;
